import { dataCoinSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCoinSolid = /*#__PURE__*/createIcon(dataCoinSolid)
export default IconCoinSolid
